import TemporaryCash from './TemporaryCash';

export default TemporaryCash;
